module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/logout-03a23a1d39a032d0f652e79b49ab9a0e.svg";